module.exports = __webpack_public_path__ + "img/lauberganggelaender.85f4124a.jpg";